module.exports = __webpack_public_path__ + "img/filter_icon1.c7b1fa7b.svg";